import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const SecurityValidationIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66602 8.83333C6.66602 8.83333 6.99935 8.83333 7.33268 9.5C7.33268 9.5 8.39148 7.83333 9.33268 7.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3327 8.49935C11.3327 10.3403 9.84028 11.8327 7.99935 11.8327C6.1584 11.8327 4.66602 10.3403 4.66602 8.49935C4.66602 6.6584 6.1584 5.16602 7.99935 5.16602C9.84028 5.16602 11.3327 6.6584 11.3327 8.49935Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14 7.95618V6.02084C14 4.92751 14 4.38084 13.7306 4.02418C13.4612 3.66751 12.8521 3.49436 11.6338 3.14805C10.8015 2.91145 10.0677 2.6264 9.48153 2.36618C8.68227 2.01138 8.28267 1.83398 8 1.83398C7.71733 1.83398 7.31773 2.01138 6.51847 2.36618C5.93226 2.6264 5.19856 2.91144 4.36622 3.14805C3.14795 3.49436 2.53881 3.66751 2.26941 4.02418C2 4.38084 2 4.92751 2 6.02084V7.95618C2 11.7063 5.37518 13.9563 7.06267 14.8469C7.4674 15.0605 7.66973 15.1673 8 15.1673C8.33027 15.1673 8.5326 15.0605 8.93733 14.8469C10.6248 13.9563 14 11.7063 14 7.95618Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
